import { ScoreRange } from '@vizit/constants';

/**
 * Returns a likert label for the given score.
 *
 * @param score - Numeric score (0-100), or null for unscored.
 * @param abbreviated - When true, returns "Med" instead of "Medium". Default: false.
 * @returns 'N/A' | 'Low' | 'Med' | 'Medium' | 'High'
 */
export function getLikertLabel(score: number | null, abbreviated = false): string {
  if (score == null) return 'N/A';
  if (score < 40) return 'Low';
  if (score < 80) return abbreviated ? 'Med' : 'Medium';
  return 'High';
}

export function getLikertScoreRange(score: number | null): ScoreRange {
  if (score == null) return ScoreRange.NotApplicable;
  if (score < 40) return ScoreRange.Low;
  if (score < 80) return ScoreRange.Moderate;
  return ScoreRange.High;
}
